/**
 * 禁用动画
 */
import fvAnimation from "./fvAnimation"
export default class fvForbid extends fvAnimation {
    constructor(shape){
        super(shape,"fvForbid");
        this.sizeFunction = AsyncFunction("return " + this.expression);
    }

    async run(){
        var size = await this.executionScript(this.sizeFunction);
       // 表达式已取反不需要判断condition
        this.shape.Enable(size);
    }
}


// WEBPACK FOOTER //
// ./src/js/div/animationDiv/fvForbid.js